<template>
  <div class="contractDetail">
    <div class="contractDetailItem">
      <div class="orderContract">
        订单协议
      </div>
      <div class="spaceBetween">
        <div class="spaceBetweenLeft">
          订单编号
        </div>
        <div>
          {{orderId}}
        </div>
      </div>

      <div class="spaceBetween">
        <div class="spaceBetweenLeft">
          申请时间
        </div>
        <div class="mapvalue">
          {{createTime}}
        </div>
      </div>

      <div v-if="orderContractList.length > 0">
        <div
          class="spaceBetween"
          v-for="(e, index) in orderContractList"
          :key="index"
        >
          <div
            class="spaceBetweenLeft"
            v-if="index === 0"
          >
            协议清单
          </div>
          <div v-else></div>
          <div
            class="spaceBetweenRight"
            @click="clickContract(e.id,e.ossKey)"
          >
            《{{e.contractMessage}}》
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="drawContractList.length > 0"
      class="orderContract"
    >
      借款协议
    </div>
    <div
      v-for="(e, index) in drawContractList"
      :key="index"
      class="contractDetailItem"
    >
      <div class="spaceBetween">
        <div class="spaceBetweenLeft">
          借据号
        </div>
        <div>
          {{e.cino}}
        </div>
      </div>

      <div class="spaceBetween">
        <div class="spaceBetweenLeft">
          申请时间
        </div>
        <div class="mapvalue">
          {{e.createTime}}
        </div>
      </div>

      <div v-if="e.drawContractInfoList.length > 0">
        <div
          class="spaceBetween"
          v-for="(e, index) in e.drawContractInfoList"
          :key="index"
        >
          <div
            class="spaceBetweenLeft"
            v-if="index === 0"
          >
            协议清单
          </div>
          <div v-else></div>
          <div
            class="spaceBetweenRight"
            @click="clickContract(e.id,e.ossKey)"
          >
            《{{e.contractMessage}}》
          </div>
        </div>
      </div>
    </div>
    <my-popup
      :contractId="contractId"
      v-model="isShowPopup"
      :ossKey="ossKey"
    />
  </div>
</template>

<script>
import MyPopup from '@/components/myPopupContract.vue';

export default {
  name: 'contractDetail',
  components: {
    MyPopup,
  },
  data() {
    return {
      isShowPopup: false,
      orderContractList: [],
      drawContractList: [],
      orderId: '',
      createTime: '',
      contractId: '',
      ossKey: '',
    };
  },
  mounted() {
    this.queryContractInfo();
  },
  methods: {
    async queryContractInfo() {
      const toast = this.$toast.loading({
        message: '加载中...',
        clear: true,
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
      });
      const { orderId } = this.$router.currentRoute.query;
      const res = await this.$api.PublicPage.queryContractInfo({
        orderId,
      });
      if (res.success) {
        this.orderContractList = res.data.orderContractList;
        this.drawContractList = res.data.drawContractList;
        this.orderId = res.data.orderId;
        this.createTime = res.data.createTime;
      } else {
        this.$toast.fail({
          message: res.returnMessage,
          forbidClick: true,
          duration: 2500,
        });
      }
      toast.clear();
    },


    clickContract(e, ossKey) {
      this.contractId = e;
      this.ossKey = ossKey;
      this.isShowPopup = true;
    },
  },
};
</script>
<style scoped>
.contractDetailItem {
  margin-bottom: 8px;
  background: #fff;
}
.contractDetail {
  margin-bottom: 8px;
}
.orderContract {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
  height: 50px;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 15px;
  background: #fff;
  border-bottom: 1px solid #dddee1;
}
.spaceBetween {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  padding: 0 16px;
}
.spaceBetweenRight {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #ff6538;
}
.spaceBetweenLeft {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #495060;
}
.mapvalue {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #001f33;
}
</style>
